import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import { SxProps, Theme } from '@mui/material/styles'
import React from 'react'
import { getButtonTestId } from './getButtonTestId'

/** @notExported */
interface CaleoPrimaryButtonProps {
  /** the action to perform when the button is clicked. */
  clickAction: (e: React.MouseEvent<HTMLButtonElement>) => void
  /** if the button should be disabled or not. */
  valid: boolean
  /** the label to display on the button. */
  label: React.ReactNode
  /** id of the button. */
  id?: string
  /** test id of the button. */
  testId?: string
  /** if the button is loading. */
  loading?: boolean
  /** the sx prop for the button. */
  sx?: SxProps<Theme> | undefined
  /** the size of the button. */
  size?: 'small' | 'medium'
}

/**
 * Caleo primary button.
 *
 * @returns Caleo primary button component.
 * @notExported
 * @category Buttons
 */
const CaleoPrimaryButton: React.FC<CaleoPrimaryButtonProps> = ({
  clickAction,
  valid,
  label,
  id,
  testId,
  loading,
  sx,
  size,
}) => {
  const resolvedTestId = getButtonTestId({ fallback: 'button-primary', id, label, testId })

  return (
    <Button
      id={id}
      data-testid={resolvedTestId}
      type="button"
      variant="contained"
      disabled={!valid}
      onClick={(e: React.MouseEvent<HTMLButtonElement>) => clickAction(e)}
      color="primary"
      sx={sx}
      size={size}
    >
      {loading ? <CircularProgress size={24} style={{ color: 'white' }} /> : label}
    </Button>
  )
}

export default CaleoPrimaryButton
